import { gql } from '@apollo/client';

const createOAuthAuthorizationUrl = ({ vkn, bankCode, uid }) => {
  return {
    mutation: gql`
      mutation CreateOAuthAuthorizationUrl($vkn: String!, $bankCode: Int!, $uid: String!) {
        companyAccountMutation {
          createOAuthAuthorizationUrl(vkn: $vkn, bankCode: $bankCode, uid: $uid) {
            authorizationUrl
            expiresAtUtc
          }
        }
      }
    `,
    variables: {
      vkn,
      bankCode,
      uid,
    },
  };
};

export default createOAuthAuthorizationUrl;
